module.exports = __webpack_public_path__ + "static/media/logo-camaraprimeiracruz.fa00aeb2.png";